"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var styles = require("./index.module.css");
var PictureButton = function (_a) {
    var className = _a.className, childrenClassName = _a.childrenClassName, style = _a.style, children = _a.children, link = _a.link, imageWidth = _a.imageWidth, imageHeight = _a.imageHeight, imageSrc = _a.imageSrc;
    // https://github.com/Microsoft/TypeScript/issues/28768
    var LinkComponent = link ? link[1] : 'button';
    var halfWidth = imageWidth / 2;
    var halfHeight = imageHeight / 2;
    return (React.createElement(LinkComponent, { to: link && link[0], className: classnames_1.default(styles.pictureButton, className), style: style },
        React.createElement("svg", { viewBox: "0 0 " + imageWidth + " " + imageHeight },
            React.createElement("g", { transform: "translate(" + halfWidth + "," + halfHeight + ")" },
                React.createElement("g", { className: styles.scaleArea },
                    React.createElement("image", { xlinkHref: imageSrc, x: -halfWidth, y: -halfHeight, width: imageWidth, height: imageHeight })))),
        React.createElement("div", { className: styles.gradient }),
        React.createElement("div", { className: classnames_1.default(styles.children, childrenClassName) }, children)));
};
exports.default = PictureButton;
